import Container from './BatchEditOrDeleteConfirmation.container';
import BatchEditOrDeleteConfirmation from './BatchEditOrDeleteConfirmation';

export default Container(BatchEditOrDeleteConfirmation);
